import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

const superagent = superagentPromise(_superagent, global.Promise);
const STAYMENU_API_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/api`;
const STAYCHAT_API_URL = process.env.REACT_APP_STAYCHAT_API;
const TOKEN_KEY = 'X-STAYMENU-KEY';
const TOKEN_VALUE = process.env.REACT_APP_STAYMENU_API_KEY;

const response = res => {
    return res.body;
};

const responseAll = res => {
    return res;
};

const handleErrors = err => {
    if (err && err.response && err.response.status === 401) {

    } else if (err && err.response && err.response.status === 403) {

    }
    return err;
};

// GENERAL REQUEST

const stayMenuApiRequest = {
    get: async url => {
        return superagent
            .get(`${STAYMENU_API_URL}${url}`)
            .set(TOKEN_KEY, TOKEN_VALUE)
            .end(handleErrors)
            .then(response);
    },
    post: async (url, body) => {
        return superagent
            .post(`${STAYMENU_API_URL}${url}`, body)
            .set(TOKEN_KEY, TOKEN_VALUE)
            .end(handleErrors)
            .then(response);
    },
    put: async (url, body) => {
        return superagent
            .put(`${STAYMENU_API_URL}${url}`, body)
            .set(TOKEN_KEY, TOKEN_VALUE)
            .end(handleErrors)
            .then(response);
    },
    del: async (url) => {
        return superagent
            .del(`${STAYMENU_API_URL}${url}`)
            .set(TOKEN_KEY, TOKEN_VALUE)
            .end(handleErrors)
            .then(response);
    },
}

const stayChatApiRequest = {
    post: async (url, body) => {
        return superagent
            .post(`${STAYCHAT_API_URL}${url}`, body)
            .end(handleErrors)
            .then(response);
    },
    put: async (url, body) => {
        return superagent
            .put(`${STAYCHAT_API_URL}${url}`, body)
            .end(handleErrors)
            .then(response);
    }
}

// UPLOAD REQUEST

const stayMenuApiUploadRequest = {
    post: async (url, file) => {
        return superagent
            .post(`${STAYMENU_API_URL}${url}`)
            .set(TOKEN_KEY, TOKEN_VALUE)
            .attach('files', file)
            .end(handleErrors)
            .then(response);
    }
}
const stayMenuApiDownloadRequest = {
    post: async (url, file) => {
        return superagent
            .post(`${STAYMENU_API_URL}${url}`)
            .attach('files', file)
            .end(handleErrors)
            .then(responseAll);
    }
}

const stayChatApiUploadRequest = {
    post: async (url, file) => {
        return superagent
            .post(`${STAYCHAT_API_URL}${url}`)
            .attach('files', file)
            .end(handleErrors)
            .then(response);
    }
}

// RESOURCES

const AssignRoleItem = {
    apiGetAssignRoleItem: () => stayMenuApiRequest.get(`/AssignRoleItems`),
}

const Booking = {
    apiGetBookings: () => stayMenuApiRequest.get(`/Booking`)
}

const BookingCategories = {
    getAll: () => stayMenuApiRequest.get(`/BookingCategories`),
    getById: (id) => stayMenuApiRequest.get(`/BookingCategories/${id}`),
    create: (request) => stayMenuApiRequest.post(`/BookingCategories`, request),
    update: (request) => stayMenuApiRequest.put(`/BookingCategories`, request),
    delete: (id) => stayMenuApiRequest.del(`/BookingCategories/${id}`)
}

const BookingSubCategories = {
    getAll: () => stayMenuApiRequest.get(`/BookingSubCategories`),
    getById: (id) => stayMenuApiRequest.get(`/BookingSubCategories/${id}`),
    create: (request) => stayMenuApiRequest.post(`/BookingSubCategories`, request),
    update: (request) => stayMenuApiRequest.put(`/BookingSubCategories`, request),
    delete: (id) => stayMenuApiRequest.del(`/BookingSubCategories/${id}`)
}

const BookingItems = {
    getAll: () => stayMenuApiRequest.get(`/BookingItems`),
    getById: (id) => stayMenuApiRequest.get(`/BookingItems/${id}`),
    create: (request) => stayMenuApiRequest.post(`/BookingItems`, request),
    update: (request) => stayMenuApiRequest.put(`/BookingItems`, request),
    delete: (id) => stayMenuApiRequest.del(`/BookingItems/${id}`)
}

const BookingSummaries = {
    getAll: (request) => stayMenuApiRequest.post(`/BookingSummaries`, request),
}

const BookingTransactions = {
    getAll: () => stayMenuApiRequest.get(`/BookingTransactions`),
    getAllByFilter: (request) => stayMenuApiRequest.post(`/BookingTransactions/filter`, request),
    getSummary: (lang) => stayMenuApiRequest.get(`/BookingTransactions/Summary?languageCode=${lang}`),
    getSummaryByFilter: (request) => stayMenuApiRequest.post(`/BookingTransactions/Summary/Filter`, request),
    getById: (id) => stayMenuApiRequest.get(`/BookingTransactions/${id}`),
    create: (request) => stayMenuApiRequest.post(`/BookingTransactions`, request),
    update: (request) => stayMenuApiRequest.put(`/BookingTransactions`, request),
    delete: (id) => stayMenuApiRequest.del(`/BookingTransactions/${id}`),
}

const Chat = {
    Auth: (username, password, customerId, lastName) => stayChatApiRequest.post('/account/websocket', {
        'username': username,
        'password': password,
        'customerId': customerId,
        'lastName': lastName
    }),
    Load: (nodeName, customerId) => stayChatApiRequest.post('/StayMenuChats/Load', {
        'nodeName': nodeName,
        'customerId': customerId
    }),
    Send: (nodeName, customerId, message, customerName) => stayChatApiRequest.post('/StayMenuChats/Send', {
        'nodeName': nodeName,
        'customerId': customerId,
        'message': message,
        'customerName': customerName
    }),
    SendVoice: (file, nodeName, customerId, customerName) => stayChatApiUploadRequest.post(`/StayMenuChats/SendVoice?nodeName=${nodeName}&customerId=${customerId}&customerName=${customerName}`, file),
    SendFile: (file, nodeName, customerId, customerName) => stayChatApiUploadRequest.post(`/StayMenuChats/SendFile?nodeName=${nodeName}&customerId=${customerId}&customerName=${customerName}`, file),
    Read: (customerId) => stayChatApiRequest.put(`/StayMenuChats/Read/${customerId}`)
}

const ChatIntent = {
    apiGetChatIntents: () => stayMenuApiRequest.get(`/ChatIntents`),
    GetById: (chatIntentID) => stayMenuApiRequest.get(`/ChatIntents/${chatIntentID}`),
    Update: (chatIntentID, intentName, intentRedirectName, intentRedirectUrl, answer) => stayMenuApiRequest.put(`/ChatIntents/${chatIntentID}`, {
        'chatIntentID': chatIntentID,
        'intentName': intentName,
        'intentRedirectName': intentRedirectName,
        'intentRedirectUrl': intentRedirectUrl,
        'answer': answer
    }),
    apiCreateChatIntent: (intentName, intentRedirectName, intentRedirectUrl, answer) => stayMenuApiRequest.post(`/ChatIntents`, {
        'chatIntentID': 0,
        'intentName': intentName,
        'intentRedirectName': intentRedirectName,
        'intentRedirectUrl': intentRedirectUrl,
        'answer': answer
    }),
    Delete: (chatIntentID) => stayMenuApiRequest.del(`/ChatIntents/${chatIntentID}`),
    Import: (file) => stayMenuApiDownloadRequest.post(`/ChatIntents/import`, file)
}

const CleanRooms = {
    apiGetCleanRooms: (languageCode) => stayMenuApiRequest.get(`/CleanRooms?languageCode=${languageCode}`),
}

const Concierges = {
    apiGetConcierges: (languageCode) => stayMenuApiRequest.get(`/Concierges?languageCode=${languageCode}`),
}

const Configuration = {
    apiGetConfigurations: () => stayMenuApiRequest.get(`/Configurations`),
    apiGetConfigurationModel: () => stayMenuApiRequest.get(`/Configurations/Model`),
    apiGetConfigurationModelByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/Configurations/Model/LanguageCode?languageCode=${languageCode}`),
    apiCreateConfigurations: (configuration) => stayMenuApiRequest.post(`/Configurations`, configuration),
    apiUpdateConfigurations: (id, configuration) => stayMenuApiRequest.put(`/Configurations/${id}`, configuration)
}

const Csvs = {
    apiUploadCsvSubCategoryAndItemNames: (file, createdBy) => stayMenuApiUploadRequest.post(`/Csv/SubCategoryAndItemNames?createdBy=${createdBy}`, file),
}

const Currency = {
    apiGetCurrencies: () => stayMenuApiRequest.get(`/Currencies`),
    apiGetCurrencyFromSetting: () => stayMenuApiRequest.get(`/Currencies/FromSetting`)
}

const Department = {
    apiGetDepartments: () => stayMenuApiRequest.get(`/Departments`),
}

const DefectReports = {
    apiGetDefectReports: (languageCode) => stayMenuApiRequest.get(`/DefectReports?languageCode=${languageCode}`),
}

const Dnds = {
    apiGetDnds: (languageCode) => stayMenuApiRequest.get(`/Dnds?languageCode=${languageCode}`),
}

const Fnbs = {
    apiGetFnbs: (languageCode) => stayMenuApiRequest.get(`/Fnbs?languageCode=${languageCode}`),
}

const FrontOffices = {
    apiGetFrontOffices: (languageCode) => stayMenuApiRequest.get(`/FrontOffices?languageCode=${languageCode}`),
}

const FnbAdditionalItems = {
    apiGetFnbAdditionalItems: () => stayMenuApiRequest.get(`/FnbAdditionalItems`),
    apiGetFnbAdditionalItemByFnbAdditionalItemId: (fnbAdditionalItemId) => stayMenuApiRequest.get(`/FnbAdditionalItems/${fnbAdditionalItemId}`),
    apiGetFnbAdditionalItemsByFnbTaskId: (fnbTaskId) => stayMenuApiRequest.get(`/FnbAdditionalItems/Fnbs/${fnbTaskId}`),
    apiCreateFnbAdditionalItem: (fnbAdditionalItemRequest) => stayMenuApiRequest.post(`/FnbAdditionalItems`, fnbAdditionalItemRequest),
    apiUpdateFnbAdditionalItem: (fnbAdditionalItemId, fnbAdditionalItemRequest) => stayMenuApiRequest.put(`/FnbAdditionalItems/${fnbAdditionalItemId}`, fnbAdditionalItemRequest),
    apiDeleteFnbAdditionalItem: (fnbAdditionalItemId) => stayMenuApiRequest.del(`/FnbAdditionalItems/${fnbAdditionalItemId}`),
    putV2FnbAdditionalItemApi: (fnbAdditionalItemId, fnbAdditionalItemRequest) => stayMenuApiRequest.put(`/FnbAdditionalItems/V2/${fnbAdditionalItemId}`, fnbAdditionalItemRequest),
    postCreateV2AdditionalItemApi: (fnbAdditionalItemRequest) => stayMenuApiRequest.post(`/FnbAdditionalItems/CreateV2`, fnbAdditionalItemRequest),
}

const GuideDocuments = {
    apiGetGuideDocuments: () => stayMenuApiRequest.get(`/GuideDocuments`),
    apiGetGuideDocumentsById: (guideDocumentId) => stayMenuApiRequest.get(`/GuideDocuments/${guideDocumentId}`),
    apiCreateGuideDocument: (guideDocument) => stayMenuApiRequest.post(`/GuideDocuments`, guideDocument),
    apiUpdateGuideDocument: (guideDocumentId, guideDocument) => stayMenuApiRequest.put(`/GuideDocuments/${guideDocumentId}`, guideDocument),
    apiDeleteGuideDocument: (guideDocumentId) => stayMenuApiRequest.del(`/GuideDocuments/${guideDocumentId}`)
}

const HotelEvent = {
    apiGetHotelEvents: () => stayMenuApiRequest.get(`/HotelEvents`),
    GetAllAvailable: () => stayMenuApiRequest.get(`/HotelEvents/Actives`),
    GetById: (eventId) => stayMenuApiRequest.get(`/HotelEvents/${eventId}`),
    apiUpdateHoteEvent: (eventId,
        title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese,
        briefDesc, briefDescEnglish, briefDescChinese, briefDescChineseTraditional, briefDescThai, briefDescJapanese,
        description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese,
        startDate, endDate, imageUrl, showDate, showBannerOnly, sort) => stayMenuApiRequest.put(`/HotelEvents/${eventId}`, {
            'eventId': eventId,
            'title': title,
            'titleLang': {
                'english': titleEnglish,
                'chinese': titleChinese,
                'chineseTraditional': titleChineseTraditional,
                'thai': titleThai,
                'japanese': titleJapanese
            },
            'briefDesc': briefDesc,
            'briefDescLang': {
                'english': briefDescEnglish,
                'chinese': briefDescChinese,
                'chineseTraditional': briefDescChineseTraditional,
                'thai': briefDescThai,
                'japanese': briefDescJapanese
            },
            'description': description,
            'descriptionLang': {
                'english': descriptionEnglish,
                'chinese': descriptionChinese,
                'chineseTraditional': descriptionChineseTraditional,
                'thai': descriptionThai,
                'japanese': descriptionJapanese
            },
            'startDate': startDate,
            'endDate': endDate,
            'imageUrl': imageUrl,
            'showDate': showDate,
            'showBannerOnly': showBannerOnly,
            'createdAt': '2020-01-29T12:39:36.542Z',
            'isDeleted': false,
            'sort': sort
        }),
    apiCreateHotelEvent: (title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese,
        briefDesc, briefDescEnglish, briefDescChinese, briefDescChineseTraditional, briefDescThai, briefDescJapanese,
        description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese,
        startDate, endDate, imageUrl, showDate, showBannerOnly, sort) => stayMenuApiRequest.post(`/HotelEvents`, {
            'eventId': 0,
            'title': title,
            'titleLang': {
                'english': titleEnglish,
                'chinese': titleChinese,
                'chineseTraditional': titleChineseTraditional,
                'thai': titleThai,
                'japanese': titleJapanese
            },
            'briefDesc': briefDesc,
            'briefDescLang': {
                'english': briefDescEnglish,
                'chinese': briefDescChinese,
                'chineseTraditional': briefDescChineseTraditional,
                'thai': briefDescThai,
                'japanese': briefDescJapanese
            },
            'description': description,
            'descriptionLang': {
                'english': descriptionEnglish,
                'chinese': descriptionChinese,
                'chineseTraditional': descriptionChineseTraditional,
                'thai': descriptionThai,
                'japanese': descriptionJapanese
            },
            'startDate': startDate,
            'endDate': endDate,
            'imageUrl': imageUrl,
            'showDate': showDate,
            'showBannerOnly': showBannerOnly,
            'createdAt': '2020-01-29T12:39:36.542Z',
            'isDeleted': false,
            'sort': sort
        }),
    Delete: (eventId) => stayMenuApiRequest.del(`/HotelEvents/${eventId}`)
}

const Compendium = {
    apiGetCompendiums: () => stayMenuApiRequest.get(`/Compendiums`),
    GetAllAvailable: () => stayMenuApiRequest.get(`/Compendiums/Actives`),
    GetById: (compendiumId) => stayMenuApiRequest.get(`/Compendiums/${compendiumId}`),
    apiUpdateCompendium: (compendiumId,
        title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese,
        description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese,
        imageUrl, sort) => stayMenuApiRequest.put(`/Compendiums/${compendiumId}`, {
            'compendiumId': compendiumId,
            'title': title,
            'titleLang': {
                'english': titleEnglish,
                'chinese': titleChinese,
                'chineseTraditional': titleChineseTraditional,
                'thai': titleThai,
                'japanese': titleJapanese
            },
            'description': description,
            'descriptionLang': {
                'english': descriptionEnglish,
                'chinese': descriptionChinese,
                'chineseTraditional': descriptionChineseTraditional,
                'thai': descriptionThai,
                'japanese': descriptionJapanese
            },
            'imageUrl': imageUrl,
            'sort': sort
        }),
    apiCreateCompendium: (title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese,
        description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese,
        imageUrl, sort) => stayMenuApiRequest.post(`/Compendiums`, {
            'compendiumId': 0,
            'title': title,
            'titleLang': {
                'english': titleEnglish,
                'chinese': titleChinese,
                'chineseTraditional': titleChineseTraditional,
                'thai': titleThai,
                'japanese': titleJapanese
            },
            'description': description,
            'descriptionLang': {
                'english': descriptionEnglish,
                'chinese': descriptionChinese,
                'chineseTraditional': descriptionChineseTraditional,
                'thai': descriptionThai,
                'japanese': descriptionJapanese
            },
            'imageUrl': imageUrl,
            'sort': sort
        }),
    Delete: (compendiumId) => stayMenuApiRequest.del(`/Compendiums/${compendiumId}`)
}

const HotelFacility = {
    apiGetHotelFacilities: () => stayMenuApiRequest.get(`/HotelFacilities`),
    GetAllAvailable: () => stayMenuApiRequest.get(`/HotelFacilities/Actives`),
    GetById: (facilityId) => stayMenuApiRequest.get(`/HotelFacilities/${facilityId}`),
    Update: (facilityId, title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese, briefDesc, briefDescEnglish, briefDescChinese, briefDescChineseTraditional, briefDescThai, briefDescJapanese, description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese, startDate, endDate, imageUrl, sort) => stayMenuApiRequest.put(`/HotelFacilities/${facilityId}`, {
        'facilityId': facilityId,
        'title': title,
        'titleLang': {
            'english': titleEnglish,
            'chinese': titleChinese,
            'chineseTraditional': titleChineseTraditional,
            'thai': titleThai,
            'japanese': titleJapanese
        },
        'briefDesc': briefDesc,
        'briefDescLang': {
            'english': briefDescEnglish,
            'chinese': briefDescChinese,
            'chineseTraditional': briefDescChineseTraditional,
            'thai': briefDescThai,
            'japanese': briefDescJapanese
        },
        'description': description,
        'descriptionLang': {
            'english': descriptionEnglish,
            'chinese': descriptionChinese,
            'chineseTraditional': descriptionChineseTraditional,
            'thai': descriptionThai,
            'japanese': descriptionJapanese
        },
        'startDate': startDate,
        'endDate': endDate,
        'imageUrl': imageUrl,
        'createdAt': '2020-01-29T12:39:36.542Z',
        'isDeleted': false,
        'sort': sort
    }),
    apiCreateHotelFacility: (title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese, briefDesc, briefDescEnglish, briefDescChinese, briefDescChineseTraditional, briefDescThai, briefDescJapanese, description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese, startDate, endDate, imageUrl, sort) => stayMenuApiRequest.post(`/HotelFacilities`, {
        'facilityId': 0,
        'title': title,
        'titleLang': {
            'english': titleEnglish,
            'chinese': titleChinese,
            'chineseTraditional': titleChineseTraditional,
            'thai': titleThai,
            'japanese': titleJapanese
        },
        'briefDesc': briefDesc,
        'briefDescLang': {
            'english': briefDescEnglish,
            'chinese': briefDescChinese,
            'chineseTraditional': briefDescChineseTraditional,
            'thai': briefDescThai,
            'japanese': briefDescJapanese
        },
        'description': description,
        'descriptionLang': {
            'english': descriptionEnglish,
            'chinese': descriptionChinese,
            'chineseTraditional': descriptionChineseTraditional,
            'thai': descriptionThai,
            'japanese': descriptionJapanese
        },
        'startDate': startDate,
        'endDate': endDate,
        'imageUrl': imageUrl,
        'createdAt': '2020-01-29T12:39:36.542Z',
        'isDeleted': false,
        'sort': sort
    }),
    Delete: (facilityId) => stayMenuApiRequest.del(`/HotelFacilities/${facilityId}`)
}

const HotelTvChannel = {
    GetAll: () => stayMenuApiRequest.get(`/TvChannels`),
    GetById: (tvChannelID) => stayMenuApiRequest.get(`/TvChannels/${tvChannelID}`),
    Update: (tvChannelID, channel, tvChannelName) => stayMenuApiRequest.put(`/TvChannels/${tvChannelID}`, {
        'tvChannelID': tvChannelID,
        'channel': channel,
        'tvChannelName': tvChannelName,
        'companyID': 0,
        'isDeleted': false
    }),
    Create: (channel, tvChannelName) => stayMenuApiRequest.post(`/TvChannels`, {
        'tvChannelID': 0,
        'channel': channel,
        'tvChannelName': tvChannelName,
        'companyID': 0,
        'isDeleted': false
    }),
    Delete: (tvChannelID) => stayMenuApiRequest.del(`/TvChannels/${tvChannelID}`),
    apiGetCategory: () => stayMenuApiRequest.get(`/TvChannels/Category`),
    apiCreateOrUpdateCategory: (english, japanese, chinese, chineseTraditional, thailand) => stayMenuApiRequest.post(`/TvChannels/Category`, {
        'name': 'TV Channel',
        'english': english,
        'japanese': japanese,
        'chinese': chinese,
        'chineseTraditional': chineseTraditional,
        'thailand': thailand
    })
}

const HousekeepingOptIns = {
    apiGetHousekeepingOptInByRoomNumberAndGuestId: (roomNumber, guestId) => stayMenuApiRequest.get(`/HousekeepingOptIns/RoomNumber/${roomNumber}/GuestId/${guestId}`),
    apiUpdateHousekeepingOptIn: (housekeepingOptInId, housekeepingOptIn) => stayMenuApiRequest.put(`/HousekeepingOptIns/${housekeepingOptInId}`, housekeepingOptIn),
}

const HousekeepingLinenChanges = {
    apiGetHousekeepingLinenChangeByRoomNumberAndGuestId: (roomNumber, guestId) => stayMenuApiRequest.get(`/HousekeepingLinenChanges/RoomNumber/${roomNumber}/GuestId/${guestId}`),
    apiUpdateHousekeepingLinenChange: (housekeepingLinenChangeId, housekeepingLinenChange) => stayMenuApiRequest.put(`/HousekeepingLinenChanges/${housekeepingLinenChangeId}`, housekeepingLinenChange),
}

const Item = {
    apiCreateItem: (departmentID, defaultToUserType,
        taskName,
        taskNameEnglish, taskNameChinese, taskNameChineseTraditional, taskNameThai, taskNameJapanese,
        taskDescEnglish, taskDescChinese, taskDescChineseTraditional, taskDescThai, taskDescJapanese,
        imageUrl, parentId, stock, minimumStock, requestLimit, dailyRequestLimit, price, nextCount,
        startTime, endTime, sortID) => stayMenuApiRequest.post(`/Items/Management`, {
            'taskId': 0,
            'departmentID': departmentID,
            'defaultToUserType': defaultToUserType,
            'taskName': taskName,
            'taskNameLang': {
                'english': taskNameEnglish,
                'chinese': taskNameChinese,
                'chineseTraditional': taskNameChineseTraditional,
                'thai': taskNameThai,
                'japanese': taskNameJapanese
            },
            'taskDesc': taskDescEnglish,
            'taskDescLang': {
                'english': taskDescEnglish,
                'chinese': taskDescChinese,
                'chineseTraditional': taskDescChineseTraditional,
                'thai': taskDescThai,
                'japanese': taskDescJapanese
            },
            'imageUrl': imageUrl,
            'total': stock,
            'price': price,
            'parentId': parentId,
            'categoryName': 'string',
            'subCategoryName': 'string',
            'parentName': 'string',
            'minimumStock': minimumStock,
            'nextCount': nextCount,
            'requestLimit': requestLimit,
            'dailyRequestLimit': dailyRequestLimit,
            'startTime': startTime,
            'endTime': endTime,
            'sortID': sortID
        }),
    apiUpdateItem: (taskId, departmentID, defaultToUserType,
        taskName,
        taskNameEnglish, taskNameChinese, taskNameChineseTraditional, taskNameThai, taskNameJapanese,
        taskDescEnglish, taskDescChinese, taskDescChineseTraditional, taskDescThai, taskDescJapanese,
        imageUrl, parentId, stock, minimumStock, requestLimit, dailyRequestLimit, price,
        startTime, endTime, sortID) => stayMenuApiRequest.put(`/Items/${taskId}/Management`, {
            'taskId': taskId,
            'departmentID': departmentID,
            'defaultToUserType': defaultToUserType,
            'taskName': taskName,
            'taskNameLang': {
                'english': taskNameEnglish,
                'chinese': taskNameChinese,
                'chineseTraditional': taskNameChineseTraditional,
                'thai': taskNameThai,
                'japanese': taskNameJapanese
            },
            'taskDesc': taskDescEnglish,
            'taskDescLang': {
                'english': taskDescEnglish,
                'chinese': taskDescChinese,
                'chineseTraditional': taskDescChineseTraditional,
                'thai': taskDescThai,
                'japanese': taskDescJapanese
            },
            'imageUrl': imageUrl,
            'total': stock,
            'price': price,
            'parentId': parentId,
            'categoryName': 'string',
            'subCategoryName': 'string',
            'parentName': 'string',
            'minimumStock': minimumStock,
            'requestLimit': requestLimit,
            'dailyRequestLimit': dailyRequestLimit,
            'startTime': startTime,
            'endTime': endTime,
            'sortID': sortID
        }),
    apiDeleteItem: (taskId) => stayMenuApiRequest.del(`/Items/${taskId}/Management`),
    apiUpdateStock: (taskId, stock) => stayMenuApiRequest.put(`/Items/OutOfStocks/${taskId}`, {
        'stock': stock
    }),
    apiGetStayMenuCategories: () => stayMenuApiRequest.get(`/Items/StayMenuCategories`),
    apiGetStayMenuTree: () => stayMenuApiRequest.get(`/Items/StayMenu/Tree`),
    apiGetItemByTaskId: (taskId) => stayMenuApiRequest.get(`/Items/${taskId}`),
    apiGetItemByItemName: (taskName) => stayMenuApiRequest.get(`/Items?taskName=${taskName}`),
    apiGetItemsByCategoryTaskId: (categoryTaskId) => stayMenuApiRequest.get(`/Items/Category/${categoryTaskId}`),
    apiGetParents: () => stayMenuApiRequest.get(`/Items/Parents`),
    apiGetLastChilds: () => stayMenuApiRequest.get(`/Items/LastChilds`),
    apiGetFnbRecommendationByItem: () => stayMenuApiRequest.get(`/Items/Fnbs/Recommendation/Item`),
    apiGetFnbRecommendationBySubCategory: () => stayMenuApiRequest.get(`/Items/Fnbs/Recommendation/SubCategory`),
    apiGetLaundries: () => stayMenuApiRequest.get(`/Items/Laundries`),
    apiGetShoppings: () => stayMenuApiRequest.get(`/Items/Shoppings`),
    apiGetFnbs: () => stayMenuApiRequest.get(`/Items/Fnbs`),
    apiGetOutOfStocks: () => stayMenuApiRequest.get(`/Items/OutOfStocks`)
}

const ItemRecommendation = {
    apiGetItemRecommendations: () => stayMenuApiRequest.get(`/Items/Recommendations`),
    apiCreateItemRecommendation: (categoryItemId, subCategoryItemId, itemId) => stayMenuApiRequest.post(`/Items/Recommendations`, {
        'itemRecommendationId': 0,
        'categoryItemId': categoryItemId,
        'subCategoryItemId': subCategoryItemId,
        'itemId': itemId
    }),
    apiCreateSubCategoryRecommendation: (subCategoryItemId) => stayMenuApiRequest.post(`/Items/Recommendations/SubCategories/${subCategoryItemId}`),
    apiDeleteItemRecommendation: (itemRecommendationId) => stayMenuApiRequest.del(`/Items/Recommendations/${itemRecommendationId}`),
    apiDeleteSubCategoryRecommendation: (subCategoryItemId) => stayMenuApiRequest.del(`/Items/Recommendations/SubCategories/${subCategoryItemId}`)
}

const LateCheckouts = {
    apiGetLateCheckouts: (languageCode) => stayMenuApiRequest.get(`/LateCheckouts?languageCode=${languageCode}`),
}

const Laundries = {
    apiGetLaundries: (languageCode) => stayMenuApiRequest.get(`/Laundries?languageCode=${languageCode}`),
}

const Order = {
    apiGetTodayOrders: (tenantId, roomNumber, guestId, langName) => stayMenuApiRequest.get(`/Order/Today?tenantId=${tenantId}&roomNumber=${roomNumber}&guestId=${guestId}&langName=${langName}`),
}

const OrderRecommendationSetups = {
    apiCreateOrderRecommendationSetup: (orderRecommendationSetup) => stayMenuApiRequest.post(`/OrderRecommendationSetups`, orderRecommendationSetup),
    apiDeleteOrderRecommendationSetup: (orderRecommendationSetupId) => stayMenuApiRequest.del(`/OrderRecommendationSetups/${orderRecommendationSetupId}`),
}

const OrderSetups = {
    apiCreateOrderSetup: (orderSetup) => stayMenuApiRequest.post(`/OrderSetups`, orderSetup),
    apiUpdateOrderSetup: (orderSetupId, orderSetup) => stayMenuApiRequest.put(`/OrderSetups/${orderSetupId}`, orderSetup),
    apiDeleteOrderSetup: (orderSetupId) => stayMenuApiRequest.del(`/OrderSetups/${orderSetupId}`),
    apiGetOrderSetups: () => stayMenuApiRequest.get(`/OrderSetups`),
    apiGetOrderRecommendationSetupsByOrderSetupId: (orderSetupId) => stayMenuApiRequest.get(`/OrderSetups/${orderSetupId}/Recommendations`)
}

const PrintFile = {
    GetFilter: (printCode) => stayMenuApiRequest.get(`/PrintFiles/${printCode}`)
}

const Queries = {
    apiGetQueryOrderItemsForOrderSetup: () => stayMenuApiRequest.get(`/Queries/OrderItems/OrderSetup`),
    apiGetQueryOrderCategoriesForOrderSetup: () => stayMenuApiRequest.get(`/Queries/OrderCategories/OrderSetup`),
    apiGetQueryOrderItemsForOrderSetupForUpdate: (orderSetupId) => stayMenuApiRequest.get(`/Queries/OrderItems/OrderSetup?orderSetupId=${orderSetupId}`),
    apiGetQueryOrderCategoriesForOrderSetupForUpdate: (orderSetupId) => stayMenuApiRequest.get(`/Queries/OrderCategories/OrderSetup?orderSetupId=${orderSetupId}`),
    apiGetQueryOrderRecommendationItemsForOrderSetup: (orderSetupId) => stayMenuApiRequest.get(`/Queries/OrderRecommendationItems/OrderSetup/${orderSetupId}`),
    apiGetQueryOrderRecommendationCategoriesForOrderSetup: (orderSetupId) => stayMenuApiRequest.get(`/Queries/OrderRecommendationCategories/OrderSetup/${orderSetupId}`),
    apiGetQueryRecommendationByTaskIds: (taskIds, languageCode) => stayMenuApiRequest.post(`/Queries/Recommendations/TaskIds?languageCode=${languageCode}`, taskIds)
}

const Redis = {
    apiGetLatestRedis: () => stayMenuApiRequest.get(`/Redis/Init`)
}

const RetailOffer = {
    GetAll: () => stayMenuApiRequest.get(`/RetailOffers`),
    GetAllAvailable: () => stayMenuApiRequest.get(`/RetailOffers/Actives`),
    GetById: (retailOfferId) => stayMenuApiRequest.get(`/RetailOffers/${retailOfferId}`),
    apiCreateRetailOffer: (taskId,
        title,
        price,
        briefDesc,
        description,
        startDate, endDate,
        imageUrl, showBannerOnly, sort,
        retailOfferLanguages) => stayMenuApiRequest.post(`/RetailOffers`, {
            'retailOfferId': 0,
            'taskId': taskId,
            'title': title,
            'price': price,
            'taskName': 'string',
            'briefDesc': briefDesc,
            'description': description,
            'startDate': startDate,
            'endDate': endDate,
            'imageUrl': imageUrl,
            'createdAt': '2020-01-29T12:39:36.542Z',
            'isDeleted': false,
            'showBannerOnly': showBannerOnly,
            'sort': sort,
            'retailOfferLanguages': retailOfferLanguages
        }),
    apiUpdateRetailOffer: (retailOfferId, taskId,
        title,
        price,
        briefDesc,
        description,
        startDate, endDate,
        imageUrl, showBannerOnly, sort,
        retailOfferLanguages) => stayMenuApiRequest.put(`/RetailOffers/${retailOfferId}`, {
            'retailOfferId': retailOfferId,
            'taskId': taskId,
            'title': title,
            'taskName': 'string',
            'briefDesc': briefDesc,
            'description': description,
            'price': price,
            'startDate': startDate,
            'endDate': endDate,
            'imageUrl': imageUrl,
            'createdAt': '2020-01-29T12:39:36.542Z',
            'isDeleted': false,
            'showBannerOnly': showBannerOnly,
            'sort': sort,
            'retailOfferLanguages': retailOfferLanguages
        }),
    Delete: (retailOfferId) => stayMenuApiRequest.del(`/RetailOffers/${retailOfferId}`)
}

const SpecialOffer = {
    GetAll: () => stayMenuApiRequest.get(`/SpecialOffers`),
    GetAllAvailable: () => stayMenuApiRequest.get(`/SpecialOffers/Actives`),
    GetById: (specialOfferId) => stayMenuApiRequest.get(`/SpecialOffers/${specialOfferId}`),
    apiCreateSpecialOffer: (taskId,
        title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese, titleArabic,
        price,
        briefDesc, briefDescEnglish, briefDescChinese, briefDescChineseTraditional, briefDescThai, briefDescJapanese, briefDescArabic,
        description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese, descriptionArabic,
        startDate, endDate,
        imageUrl, showBannerOnly, sort) => stayMenuApiRequest.post(`/SpecialOffers`, {
            'specialOfferId': 0,
            'taskId': taskId,
            'title': title,
            'titleLang': {
                'english': titleEnglish,
                'chinese': titleChinese,
                'chineseTraditional': titleChineseTraditional,
                'thai': titleThai,
                'japanese': titleJapanese,
                'arabic': titleArabic
            },
            'price': price,
            'taskName': 'string',
            'briefDesc': briefDesc,
            'briefDescLang': {
                'english': briefDescEnglish,
                'chinese': briefDescChinese,
                'chineseTraditional': briefDescChineseTraditional,
                'thai': briefDescThai,
                'japanese': briefDescJapanese,
                'arabic': briefDescArabic
            },
            'description': description,
            'descriptionLang': {
                'english': descriptionEnglish,
                'chinese': descriptionChinese,
                'chineseTraditional': descriptionChineseTraditional,
                'thai': descriptionThai,
                'japanese': descriptionJapanese,
                'arabic': descriptionArabic
            },
            'startDate': startDate,
            'endDate': endDate,
            'imageUrl': imageUrl,
            'createdAt': '2020-01-29T12:39:36.542Z',
            'isDeleted': false,
            'showBannerOnly': showBannerOnly,
            'sort': sort
        }),
    apiUpdateSpecialOffer: (specialOfferId, taskId,
        title, titleEnglish, titleChinese, titleChineseTraditional, titleThai, titleJapanese, titleArabic,
        price,
        briefDesc, briefDescEnglish, briefDescChinese, briefDescChineseTraditional, briefDescThai, briefDescJapanese, briefDescArabic,
        description, descriptionEnglish, descriptionChinese, descriptionChineseTraditional, descriptionThai, descriptionJapanese, descriptionArabic,
        startDate, endDate,
        imageUrl, showBannerOnly, sort) => stayMenuApiRequest.put(`/SpecialOffers/${specialOfferId}`, {
            'specialOfferId': specialOfferId,
            'taskId': taskId,
            'title': title,
            'titleLang': {
                'english': titleEnglish,
                'chinese': titleChinese,
                'chineseTraditional': titleChineseTraditional,
                'thai': titleThai,
                'japanese': titleJapanese,
                'arabic': titleArabic
            },
            'taskName': 'string',
            'briefDesc': briefDesc,
            'briefDescLang': {
                'english': briefDescEnglish,
                'chinese': briefDescChinese,
                'chineseTraditional': briefDescChineseTraditional,
                'thai': briefDescThai,
                'japanese': briefDescJapanese,
                'arabic': briefDescArabic
            },
            'description': description,
            'descriptionLang': {
                'english': descriptionEnglish,
                'chinese': descriptionChinese,
                'chineseTraditional': descriptionChineseTraditional,
                'thai': descriptionThai,
                'japanese': descriptionJapanese,
                'arabic': descriptionArabic
            },
            'price': price,
            'startDate': startDate,
            'endDate': endDate,
            'imageUrl': imageUrl,
            'createdAt': '2020-01-29T12:39:36.542Z',
            'isDeleted': false,
            'showBannerOnly': showBannerOnly,
            'sort': sort
        }),
    Delete: (specialOfferId) => stayMenuApiRequest.del(`/SpecialOffers/${specialOfferId}`)
}

const Timezone = {
    apiGetTimezones: () => stayMenuApiRequest.get(`/Timezones`),
    apiGetTimezoneFromSetting: () => stayMenuApiRequest.get(`/Timezones/FromSetting`)
}

const Upload = {
    apiUploadImages: (file, category, taskName) => stayMenuApiUploadRequest.post(`/Uploads?category=${category}&itemName=${taskName}`, file),
    apiUploadDocument: (file, documentName) => stayMenuApiUploadRequest.post(`/Uploads/Documents?itemName=${documentName}`, file)
}

const User = {
    apiLoginAsGuest: (companyId, roomName, userName, pushCallback) => stayMenuApiRequest.post('/User/Guest/Login', {
        'tenantId': companyId,
        'roomNumber': roomName,
        'lastName': userName
    }),
    apiLoginOnlyRoomNumber: (companyId, roomName, userName, pushCallback) => stayMenuApiRequest.post('/User/Guest/LoginByRoomNumber', {
        'tenantId': companyId,
        'roomNumber': roomName,
        'lastName': ''
    }),
    AdminLogin: (loginName, password) => stayMenuApiRequest.post('/User/Admin/Login', {
        'loginName': loginName,
        'password': password
    }),
    AdminLoginToken: (token) => stayMenuApiRequest.post('/User/Admin/LoginToken', {
        'token': token
    })
}

const Weather = {
    Get: (lang) => stayMenuApiRequest.get(`/Weather?lang=${lang}`)
}

const CmsLanguages = {
    get: () => stayMenuApiRequest.get(`/Languages`),
    getActives: () => stayMenuApiRequest.get(`/Languages/Actives`),
    update: (id, isAvailable, sort) => stayMenuApiRequest.put(`/Languages/${id}?isAvailable=${isAvailable}&sort=${sort}`),
    activate: (id) => stayMenuApiRequest.put(`/Languages/${id}/Activate`),
    deactivate: (id) => stayMenuApiRequest.put(`/Languages/${id}/Deactivate`)
}

const CmsLogins = {
    get: () => stayMenuApiRequest.get(`/LoginStyles`),
    update: (id, body) => stayMenuApiRequest.put(`/LoginStyles/${id}`, body)
}

const CmsTasks = {
    getTree: () => stayMenuApiRequest.get(`/Tasks/Tree`),
    getShorts: () => stayMenuApiRequest.get(`/Tasks/Shorts`),
    getById: (id) => stayMenuApiRequest.get(`/Tasks/${id}`),

    getSingleList: (menuId, languageId) => stayMenuApiRequest.get(`/Tasks/SingleList/Menu/${menuId}/Language/${languageId}`),

    getAmenity: (languageCode) => stayMenuApiRequest.get(`/Tasks/Amenity?languageCode=${languageCode}`),
    getAmenities: (languageCode) => stayMenuApiRequest.get(`/Tasks/Amenities?languageCode=${languageCode}`),

    getBookingFacility: (languageCode) => stayMenuApiRequest.get(`/Tasks/BookingFacility?languageCode=${languageCode}`),

    getInRoomDining: (languageCode) => stayMenuApiRequest.get(`/Tasks/InRoomDining?languageCode=${languageCode}`),
    getInRoomDinings: (languageCode) => stayMenuApiRequest.get(`/Tasks/InRoomDinings?languageCode=${languageCode}`),
    getInRoomDiningAll: (languageCode) => stayMenuApiRequest.get(`/Tasks/InRoomDiningAll?languageCode=en`),

    getLaundry: (languageCode) => stayMenuApiRequest.get(`/Tasks/Laundry?languageCode=${languageCode}`),
    getLaundries: (languageCode) => stayMenuApiRequest.get(`/Tasks/Laundries?languageCode=${languageCode}`),

    getShopping: (languageCode) => stayMenuApiRequest.get(`/Tasks/Shopping?languageCode=${languageCode}`),
    getShoppings: (languageCode) => stayMenuApiRequest.get(`/Tasks/Shoppings?languageCode=${languageCode}`),
    getShoppingAll: (languageCode) => stayMenuApiRequest.get(`/Tasks/ShoppingAll?languageCode=en`),

    getSpa: (languageCode) => stayMenuApiRequest.get(`/Tasks/Spa?languageCode=${languageCode}`),
    getSpas: (languageCode) => stayMenuApiRequest.get(`/Tasks/Spas?languageCode=${languageCode}`),

    getPrint: (languageCode) => stayMenuApiRequest.get(`/Tasks/Print?languageCode=${languageCode}`),

    getTransportation: (languageCode) => stayMenuApiRequest.get(`/Tasks/Transportation?languageCode=${languageCode}`),

    getWakeUpCall: (languageCode) => stayMenuApiRequest.get(`/Tasks/WakeUpCall?languageCode=${languageCode}`),

    getTv: (languageCode) => stayMenuApiRequest.get(`/Tasks/Tv?languageCode=${languageCode}`),

    create: (body) => stayMenuApiRequest.post(`/Tasks`, body),
    update: (id, body) => stayMenuApiRequest.put(`/Tasks/${id}`, body),
    delete: (id, deletedBy) => stayMenuApiRequest.del(`/Tasks/${id}?deletedBy=${deletedBy}`),

    getMenus: () => stayMenuApiRequest.get(`/Tasks/Menus`),
    getActiveMenus: () => stayMenuApiRequest.get(`/Tasks/Menus/Active`),
    updateMenu: (id, body) => stayMenuApiRequest.put(`/Tasks/${id}/Menus`, body),
    enabledMenu: (id) => stayMenuApiRequest.put(`/Tasks/${id}/Menus/Enabled`),
    disabledMenu: (id) => stayMenuApiRequest.put(`/Tasks/${id}/Menus/Disabled`),

    outOfStocks: () => stayMenuApiRequest.get(`/Tasks/OutOfStocks`),
    outOfStockUpdate: (id, total) => stayMenuApiRequest.put(`/Tasks/OutOfStocks/${id}/${total}`),

    getMultiList: (languageCode, languageId, taskId) => stayMenuApiRequest.get(`/Tasks/MultiList/Task/${taskId}/Language/${languageId}?languageCode=${languageCode}`),
}

const WebSettings = {
    get: (languageCode) => stayMenuApiRequest.get(`/WebSettings?languageCode=${languageCode}`),
    update: (id, body) => stayMenuApiRequest.put(`/WebSettings/${id}`, body)
}

const CmsTransactions = {
    create: (body) => stayMenuApiRequest.post(`/Transactions`, body),
    get: (tenantId, roomNumber, guestId, langName) => stayMenuApiRequest.get(`/Transactions?tenantId=${tenantId}&roomNumber=${roomNumber}&guestId=${guestId}&langName=${langName}`)
}

const CmsGuests = {
    authenticate: (body) => stayMenuApiRequest.post(`/Guests`, body)
}

const CmsClimates = {
    get: (lang) => stayMenuApiRequest.get(`/Climates/${lang}`)
}

const CmsPaymentTypes = {
    get: () => stayMenuApiRequest.get(`/PaymentTypes`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/PaymentTypes/LanguageCode/${languageCode}`),
    getById: (id) => stayMenuApiRequest.get(`/PaymentTypes/${id}`),
    getByIdAndLanguageCode: (id, languageCode) => stayMenuApiRequest.get(`/PaymentTypes/${id}/LanguageCode/${languageCode}`),
    create: (body) => stayMenuApiRequest.post(`/PaymentTypes`, body),
    update: (id, body) => stayMenuApiRequest.put(`/PaymentTypes/${id}`, body),
    delete: (id) => stayMenuApiRequest.del(`/PaymentTypes/${id}`),
}

const CmsFacilityHotels = {
    get: () => stayMenuApiRequest.get(`/FacilityHotels`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/FacilityHotels/LanguageCode/${languageCode}`),
    getById: (id) => stayMenuApiRequest.get(`/FacilityHotels/${id}`),
    getByIdAndLanguageCode: (id, languageCode) => stayMenuApiRequest.get(`/FacilityHotels/${id}/LanguageCode/${languageCode}`),
    create: (body) => stayMenuApiRequest.post(`/FacilityHotels`, body),
    update: (id, body) => stayMenuApiRequest.put(`/FacilityHotels/${id}`, body),
    delete: (id) => stayMenuApiRequest.del(`/FacilityHotels/${id}`),
}

const CmsEventHotels = {
    get: () => stayMenuApiRequest.get(`/EventHotels`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/EventHotels/LanguageCode/${languageCode}`),
    getActivesByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/EventHotels/Actives/LanguageCode/${languageCode}`),
    getById: (id) => stayMenuApiRequest.get(`/EventHotels/${id}`),
    getByIdAndLanguageCode: (id, languageCode) => stayMenuApiRequest.get(`/EventHotels/${id}/LanguageCode/${languageCode}`),
    create: (body) => stayMenuApiRequest.post(`/EventHotels`, body),
    update: (id, body) => stayMenuApiRequest.put(`/EventHotels/${id}`, body),
    delete: (id) => stayMenuApiRequest.del(`/EventHotels/${id}`),
}

const CmsHotelDescs = {
    get: () => stayMenuApiRequest.get(`/HotelDescs`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/HotelDescs/LanguageCode/${languageCode}`),
    update: (id, body) => stayMenuApiRequest.put(`/HotelDescs/${id}`, body),
}

const CmsSidebars = {
    get: () => stayMenuApiRequest.get(`/Sidebars`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/Sidebars/LanguageCode/${languageCode}`),
    getById: (id) => stayMenuApiRequest.get(`/Sidebars/${id}`),
    getByIdAndLanguageCode: (id, languageCode) => stayMenuApiRequest.get(`/Sidebars/${id}/LanguageCode/${languageCode}`),
    create: (body) => stayMenuApiRequest.post(`/Sidebars`, body),
    update: (id, body) => stayMenuApiRequest.put(`/Sidebars/${id}`, body),
    delete: (id) => stayMenuApiRequest.del(`/Sidebars/${id}`),
}

const CmsTransportationTypes = {
    get: () => stayMenuApiRequest.get(`/TransportationTypes`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/TransportationTypes/LanguageCode/${languageCode}`),
    getById: (id) => stayMenuApiRequest.get(`/TransportationTypes/${id}`),
    getByIdAndLanguageCode: (id, languageCode) => stayMenuApiRequest.get(`/TransportationTypes/${id}/LanguageCode/${languageCode}`),
    create: (body) => stayMenuApiRequest.post(`/TransportationTypes`, body),
    update: (id, body) => stayMenuApiRequest.put(`/TransportationTypes/${id}`, body),
    delete: (id) => stayMenuApiRequest.del(`/TransportationTypes/${id}`),
}

const CmsLaundryServices = {
    get: () => stayMenuApiRequest.get(`/LaundryServices`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/LaundryServices/LanguageCode/${languageCode}`),
    getById: (id) => stayMenuApiRequest.get(`/LaundryServices/${id}`),
    getByIdAndLanguageCode: (id, languageCode) => stayMenuApiRequest.get(`/LaundryServices/${id}/LanguageCode/${languageCode}`),
    create: (body) => stayMenuApiRequest.post(`/LaundryServices`, body),
    update: (id, body) => stayMenuApiRequest.put(`/LaundryServices/${id}`, body),
    delete: (id) => stayMenuApiRequest.del(`/LaundryServices/${id}`),
}

const CmsLaundryDeliveries = {
    get: () => stayMenuApiRequest.get(`/LaundryDeliveries`),
    getByLanguageCode: (languageCode) => stayMenuApiRequest.get(`/LaundryDeliveries/LanguageCode/${languageCode}`),
    getById: (id) => stayMenuApiRequest.get(`/LaundryDeliveries/${id}`),
    getByIdAndLanguageCode: (id, languageCode) => stayMenuApiRequest.get(`/LaundryDeliveries/${id}/LanguageCode/${languageCode}`),
    create: (body) => stayMenuApiRequest.post(`/LaundryDeliveries`, body),
    update: (id, body) => stayMenuApiRequest.put(`/LaundryDeliveries/${id}`, body),
    delete: (id) => stayMenuApiRequest.del(`/LaundryDeliveries/${id}`),
}

const Popup = {
    apiGetPopups: () => stayMenuApiRequest.get(`/Popups`),
    GetAllAvailable: () => stayMenuApiRequest.get(`/Popups/Actives`),
    GetById: (eventId) => stayMenuApiRequest.get(`/Popups/${eventId}`),
    GetByModuleNameAndLanguageCode: (moduleName, languageCode) => stayMenuApiRequest.get(`/Popups/ModuleName/${moduleName}/LanguageCode/${languageCode}`),
    apiUpdatePopup: (id, body) => stayMenuApiRequest.put(`/Popups/${id}`, body),
    apiCreatePopup: (body) => stayMenuApiRequest.post(`/Popups`, body),
    Delete: (eventId) => stayMenuApiRequest.del(`/Popups/${eventId}`)
}

const Template = {
    apiGetTemplates: () => stayMenuApiRequest.get(`/Templates`),
    apiGetActive: () => stayMenuApiRequest.get(`/Templates/Active`),
    GetById: (eventId) => stayMenuApiRequest.get(`/Templates/${eventId}`),
    GetByModuleNameAndLanguageCode: (moduleName, languageCode) => stayMenuApiRequest.get(`/Templates/ModuleName/${moduleName}/LanguageCode/${languageCode}`),
    apiUpdateTemplate: (id, body) => stayMenuApiRequest.put(`/Templates/${id}`, body),
    apiCreateTemplate: (body) => stayMenuApiRequest.post(`/Templates`, body),
    Delete: (eventId) => stayMenuApiRequest.del(`/Templates/${eventId}`)
}

const Exports = {
    TaskMenus: () => stayMenuApiRequest.get(`/Exports/Tasks/Menu`),
    TaskCategories: () => stayMenuApiRequest.get(`/Exports/Tasks/Category`),
    TaskSubCategories: () => stayMenuApiRequest.get(`/Exports/Tasks/SubCategory`),
    TaskItemFnbs: () => stayMenuApiRequest.get(`/Exports/Tasks/Items/Fnb`),
    TaskItemNonFnbs: () => stayMenuApiRequest.get(`/Exports/Tasks/Items/NonFnb`),
    TemplateById: (id) => stayMenuApiRequest.get(`/Exports/Template/${id}`),
}

const Imports = {
    template: (file) => stayMenuApiUploadRequest.post(`/Imports/Template`, file),
}

const Versions = {
    get: () => stayMenuApiRequest.get(`/Versions`),
}

const AuditLogs = {
    get: (request) => stayMenuApiRequest.post(`/AuditLogs/Filter`, request),
}

const OutOfStockRecipient = {
    GetAll: () => stayMenuApiRequest.get(`/OutOfStockRecipients`),
    GetById: (outOfStockRecipientId) => stayMenuApiRequest.get(`/OutOfStockRecipients/${outOfStockRecipientId}`),
    Update: (outOfStockRecipientId, email) => stayMenuApiRequest.put(`/OutOfStockRecipients`, {
        'outOfStockRecipientId': outOfStockRecipientId,
        'email': email
    }),
    Create: (email) => stayMenuApiRequest.post(`/OutOfStockRecipients`, {
        'outOfStockRecipientId': 0,
        'email': email
    }),
    Delete: (outOfStockRecipientId) => stayMenuApiRequest.del(`/OutOfStockRecipients/${outOfStockRecipientId}`)
}


const GuestLoginLogs = {
    create: (roomNumber, guestName) => stayMenuApiRequest.post(`/GuestLoginLogs?roomNumber=${roomNumber}&guestName=${guestName}`, null),
    filter: (request) => stayMenuApiRequest.post(`/GuestLoginLogs/Filter`, request),
}

const postPaymentIrdApi = (body) => {
    return stayMenuApiRequest.post(`/Payment/IRD`, body)
}

const getPaymentStatusApi = (paymentId) =>{
    return stayMenuApiRequest.get(`/Payment/Success?paymentId=${paymentId}`)
}

const PaymentLogs = {
    get: (request) => stayMenuApiRequest.post(`/PaymentHistorys/Filter`, request),
}

const Shiji = {
    apiSyncFnb: () => stayMenuApiRequest.get(`/Shijis/SyncFnb?languageCode=en`)
}

export default {
    AssignRoleItem,
    Booking,
    BookingCategories,
    BookingSubCategories,
    BookingItems,
    BookingSummaries,
    BookingTransactions,
    Chat,
    ChatIntent,
    CleanRooms,
    Concierges,
    Configuration,
    Csvs,
    Currency,
    Department,
    DefectReports,
    Dnds,
    Fnbs,
    FrontOffices,
    FnbAdditionalItems,
    GuideDocuments,
    HotelEvent,
    Compendium,
    HotelFacility,
    HotelTvChannel,
    HousekeepingOptIns,
    HousekeepingLinenChanges,
    Item,
    ItemRecommendation,
    LateCheckouts,
    Laundries,
    Order,
    OrderRecommendationSetups,
    OrderSetups,
    PrintFile,
    Queries,
    Redis,
    RetailOffer,
    SpecialOffer,
    Timezone,
    Upload,
    User,
    Weather,
    CmsLanguages,
    CmsLogins,
    CmsTasks,
    WebSettings,
    CmsTransactions,
    CmsGuests,
    CmsClimates,
    CmsPaymentTypes,
    CmsFacilityHotels,
    CmsEventHotels,
    CmsHotelDescs,
    CmsSidebars,
    CmsTransportationTypes,
    CmsLaundryDeliveries,
    CmsLaundryServices,
    Popup,
    Template,
    Exports,
    Imports,
    Versions,
    AuditLogs,
    OutOfStockRecipient,
    GuestLoginLogs,
    postPaymentIrdApi,
    getPaymentStatusApi,
    PaymentLogs,
    Shiji
}